import { render, staticRenderFns } from "./WorkflowPriceChangeModal.vue?vue&type=template&id=ed6b9f16&scoped=true"
import script from "./WorkflowPriceChangeModal.vue?vue&type=script&lang=js"
export * from "./WorkflowPriceChangeModal.vue?vue&type=script&lang=js"
import style0 from "./WorkflowPriceChangeModal.vue?vue&type=style&index=0&id=ed6b9f16&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed6b9f16",
  null
  
)

export default component.exports